import { render, staticRenderFns } from "./MisInscripciones.vue?vue&type=template&id=888270a2"
import script from "./MisInscripciones.vue?vue&type=script&lang=js"
export * from "./MisInscripciones.vue?vue&type=script&lang=js"
import style0 from "./MisInscripciones.vue?vue&type=style&index=0&id=888270a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports